import { StringSchema } from 'yup';

export const validate = (value: string) => {
  const nameRegex = /^[a-zA-Zà-úÀ-Ú\s]+$/gm;

  return nameRegex.test(value);
};

export default function (this: StringSchema, message = 'O nome não deve incluir caracteres especiais') {
  return this.test('name', message, function (value) {
    if (value.includes('*')) return true;

    const isNameValid = validate(value);

    if (isNameValid || !value) return true;

    return this.createError({ message });
  });
}
